<div class="row px-0 mx-0">
  <input [id]="input.MainElementList[0].ID" [attr.type]="input.MainElementList[0].Type" class="q-input-no-border w-100 px-0 mx-0"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="input.MainElementList[0].Value"
         [ngClass]="setClass(input, 0)">

  <textarea [id]="input.MainElementList[1].ID" class="q-input-no-border w-100 mt-2" [disabled]="input.MainElementList[1].Disabled"
            [ngClass]="setClass(input, 1)"
            [style.Height.px]="input.MainElementList[1].Height"
            [(ngModel)]="input.MainElementList[1].Value" wrap="hard">{{input.MainElementList[1].Value}}
  </textarea>
</div>
